import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { AccountChartCard } from "./AccountChartCard";

export function AccountChartPage() {
  return (
    <Box component="main" sx={{ flexGrow: 1, overflow: "auto" }}>
      <Box sx={{ flexGrow: 1, p: 3 }}>
        <Grid container rowSpacing={3} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
          <Grid item xs={12} md={12}>
            <AccountChartCard />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
